import { permissionsRol as programRol } from 'app/policies/roles/programsRol.access';
import { PATH_PROGRAM, PATH_PROGRAMS, PATH_PROGRAM_CREATE, PATH_PROGRAM_DISTRIBUTION_EDITOR, PATH_PROGRAM_STEP } from 'app/router/routesConfigPrograms';

export function programs(path, user) {
  if (PATH_PROGRAM === path) {
    return programRol(user).readDetail;
  }

  if (PATH_PROGRAM_STEP === path) {
    return programRol(user).readDetail;
  }

  if (PATH_PROGRAM_DISTRIBUTION_EDITOR === path) {
    return programRol(user).readDetail;
  }

  if (PATH_PROGRAMS === path) {
    return programRol(user).readList;
  }

  if (PATH_PROGRAM_CREATE === path) {
    return programRol(user).create;
  }

  return true;
}
